import AxiosClient from './api'
import END_POINT from './constants'

const useLocalStorage = import.meta.env.VITE_USE_LOCAL_STORAGE === 'true'

export function getAccountInfo() {
  if (useLocalStorage) {
    return Promise.resolve({
      success: true,
      result: {
        user_name: 'Local User',
        email: 'local@example.com',
        role: 'COMPANY_ADMIN'
      }
    })
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.ACCOUNT_INFO.GET_INFO}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getAllCustomerRequest() {
  if (useLocalStorage) {
    return Promise.resolve({
      success: true,
      result: {
        rows: [{ user_name: 'Local User', id: 'local' }]
      }
    })
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.GET_ALL_CUSTOMER}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.message))
  })
}

export function updateAccountInfoBasic(payload) {
  if (useLocalStorage) {
    return Promise.resolve({ success: true, result: payload })
  }
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.ACCOUNT_INFO.UPDATE_BASIC}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function updateAccountInfoBusiness(payload) {
  if (useLocalStorage) {
    return Promise.resolve({ success: true, result: payload })
  }
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.ACCOUNT_INFO.UPDATE_BUSINESS}`, payload)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
